<script setup lang="ts">
defineEmits(["update-type"]);

defineProps<{
  disabled: boolean;
  type: "uploaded" | "purchased";
}>();
</script>

<template>
  <div class="artwork-history-artworks-toggle">
    <button
      class="artwork-history-artworks-toggle__button"
      :class="{
        'artwork-history-artworks-toggle__button--active': type === 'uploaded'
      }"
      type="button"
      :disabled="disabled"
      @click="$emit('update-type', 'uploaded')"
    >
      Uploaded
    </button>

    <button
      class="artwork-history-artworks-toggle__button"
      :class="{
        'artwork-history-artworks-toggle__button--active': type === 'purchased'
      }"
      type="button"
      :disabled="disabled"
      @click="$emit('update-type', 'purchased')"
    >
      Purchased
    </button>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";
@import "frontend/init/jiffy/button/mixin.scss";

.artwork-history-artworks-toggle {
  display: flex;
  border-radius: 8px;
  gap: 4px;
  border: 1px solid $app-gray-modern-200;
  background: $white;
  height: 42px;
  padding: 3px;
  box-shadow:
    0 4px 8px -2px rgba(18, 25, 38, 0.1),
    0 2px 4px -2px rgba(18, 25, 38, 0.06);

  &__button {
    @include clear-button;

    width: 103px;
    height: 34px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;

    &--active {
      color: $white;
      background: $primary-light;
      cursor: default;
    }
  }
}
</style>
